module.exports = __webpack_public_path__ + "media/images/svgs/icon-down-arrow-0ca69eebffa4aa2c086c8addf7d8da25.svg";